import { Typography } from 'antd';
import styled from 'styled-components';

const { Paragraph } = Typography;

export const ParagraphStyled = styled(Paragraph)`
  font-size: 20px;
  text-align: center;
`;
